import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

import { ReplaySubject, BehaviorSubject, catchError, Observable } from 'rxjs';

import { MessageService } from 'src/app/core/services/message.service';
import { PageDonnee } from 'src/app/shared/interfaces/page-donnee';

@Injectable({
  providedIn: 'root'
})
export class TrajetService {

  constructor(
    private messageService: MessageService
    ,private http: HttpClient
    ) { }

   private donneesSubject = new BehaviorSubject<any[]>([]);
   public donnees$ = this.donneesSubject.asObservable();

   private chargementSubject = new BehaviorSubject<boolean>(false);
   public chargement$ = this.chargementSubject.asObservable();

   private indexPageSubject = new ReplaySubject<number>(0);
   public indexPage$ = this.indexPageSubject.asObservable();

   private taillePageSubject = new ReplaySubject<number>(10);
   public taillePage$ = this.taillePageSubject.asObservable();

   private totalElementsDonneesSubject = new BehaviorSubject<number>(0);
   public totalElementsDonnees$ = this.totalElementsDonneesSubject.asObservable();

  obtenirTrajet(): Observable<any> {
    const url = `${environment.apiurl}trajet/actifs`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirTrajetParId(id: number): Observable<any> {
    const url = `${environment.apiurl}trajet/${id}`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirListeTrajets(page:number, taille:number) {
    const url = `${environment.apiurl}trajet/actifs`;
    this.http.get<any[]>(url).subscribe(donnees => {
      const list = Array.isArray(donnees) ? donnees : [];
      this.donneesSubject.next(list);
      this.chargementSubject.next(false);
      this.indexPageSubject.next(0);
      this.totalElementsDonneesSubject.next(list.length);
    });
  }

  enregistrerTrajet(formulaireTrajet: any): Observable<any> {
    const url = `${environment.apiurl}` + 'trajet';
    return this.http.post<any>(url, formulaireTrajet).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  modifierTrajet(formulaireTrajet: any): Observable<any> {
    const url = `${environment.apiurl}` + 'trajet/' + formulaireTrajet.id;
    const { id, ...donneesTrajet } = formulaireTrajet;
    return this.http.put<any>(url, donneesTrajet).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  supprimerTrajet(id: number): Observable<any> {
    const url = `${environment.apiurl}trajet/${id}`;
    return this.http.delete<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  basculerActifTrajet(id: number, actif: boolean): Observable<any> {
    const url = `${environment.apiurl}trajet/${id}/toggle-actif?actif=${actif}`;
    return this.http.patch<any>(url, {}).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

}
